// Shopify's detected country is independent of the shopper's selected currency.
// This is browser routing, not server-side access control.
for (const config of document.querySelectorAll('[data-atl-country-redirect]')) {
  if (config.dataset.initialized) continue;
  config.dataset.initialized = 'true';
  void routeVisitor(config);
}

async function routeVisitor(config) {
  if (window.Shopify?.designMode) return;
  let destination;
  try {
    destination = new URL(config.dataset.destination);
    if (destination.protocol !== 'https:' || destination.origin === location.origin) return;
  } catch { return; }
  const allowed = config.dataset.allowed.split(',').map(value => value.trim().toUpperCase());
  const key = 'atl-detected-country-v1';
  let country;
  try {
    const cached = JSON.parse(sessionStorage.getItem(key));
    if (cached && Date.now() - cached.time < 15 * 60 * 1000 && Date.now() >= cached.time) country = cached.country;
  } catch { /* Storage may be unavailable. Detect directly. */ }
  if (!/^[A-Z]{2}$/.test(country || '')) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);
    try {
      const response = await fetch(config.dataset.endpoint, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const data = await response.json();
      country = data?.detected_values?.country?.handle;
      if (!/^[A-Z]{2}$/.test(country || '') || country === 'XX') return;
      try { sessionStorage.setItem(key, JSON.stringify({ country, time: Date.now() })); } catch { }
    } catch { return; }
    finally { clearTimeout(timeout); }
  }
  if (country !== 'XX' && !allowed.includes(country)) location.replace(destination.href);
}
